import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchAddToCartFromWishListEvent } from "@store/Services/AnalyticsService";

addToChainAfter(chain, RequestDataFromApi, props => {
    if (props.apiResult.cartLines) {
        const wishList = getWishListState(props.getState(), props.apiParameter.wishListId).value;

        const state = props.getState();
        const currentCurency = state.context.session.currency?.currencyCode;
        dispatchAddToCartFromWishListEvent(props.apiResult.cartLines, currentCurency, { ...wishList } as WishListModel);
    }
});
